module.exports = __webpack_public_path__ + "img/2024big1.697b4396.png";